import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'


const QMSProcedures = () => {

    let dataTableStructure = {};

    dataTableStructure.dataUrl = "/umbraco/api/Compliance/QMSProcedures";
    dataTableStructure.getSingleItemUrl = "/umbraco/api/Compliance/QMSProcedure";
    dataTableStructure.pageTitle = "QMS Procedures";
    dataTableStructure.singleItemTitle = "QMS Procedure Reference & Title";
    dataTableStructure.entityType = "compliance-qms";
    dataTableStructure.pageIcon = "fas fa-clipboard-list";
    dataTableStructure.breadcrumbs = [{ "Name": "Compliance Manager", "Link": "/your-medboard/compliance-portfolio/" }, { "Name": "QMS Procedures", "Link": "/your-medboard/compliance-portfolio/qms-procedures/" }]
    dataTableStructure.dataStructure = [];
    dataTableStructure.ComplianceType = "QMS";
    dataTableStructure.preLoadItemUrlParamName = "viewItemId";
    dataTableStructure.preLoadItemId = window.preloadQMSProcedureId;
    dataTableStructure.showTaskCount = true;
    dataTableStructure.showCMArchiveFilter = true;


    dataTableStructure.dataStructure.push({ name: "Reference & Title", field: "Name", width: "57%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Compliance Status", field: "Status", width: "29%", sortable: true, renderWith: FieldTypes.FieldType_Compliance_Status });
    dataTableStructure.dataStructure.push({ name: "Open Tasks", field: "TaskCount", width: "14%", sortable: true, renderWith: FieldTypes.FieldType_Open_Tasks });

    dataTableStructure.dataUrlParameters = { search: null, page: 1, orderByField: "Name", orderByType: "ASCENDING", }


    return (<>

        <DataTable dataTableStructure={dataTableStructure} />

    </>);

};




export default QMSProcedures;